import styled, { css } from 'styled-components'

type TButtonVariant = 'primary' | 'secondary' | 'danger'

const variantStyles = {
  primary: css`
    color: #ffffff;
    background-color: #4f46e5;
    border: 1px solid #4f46e5;

    &:hover:not(:disabled) {
      background-color: #4338ca;
      border-color: #4338ca;
    }
  `,
  secondary: css`
    color: #4b5563;
    background-color: #ffffff;
    border: 1px solid #d1d5db;

    &:hover:not(:disabled) {
      background-color: #f9fafb;
      border-color: #9ca3af;
    }
  `,
  danger: css`
    color: #ffffff;
    background-color: #dc2626;
    border: 1px solid #dc2626;

    &:hover:not(:disabled) {
      background-color: #b91c1c;
      border-color: #b91c1c;
    }
  `
}

export const StyledButton = styled.button<{ $variant: TButtonVariant }>`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  white-space: nowrap;

  ${({ $variant }) => variantStyles[$variant]}

  &:focus:not(:disabled) {
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`
